export default class IdList {
  ids = null;

  constructor() {
  }
}
